/* props: noCreation: n'autorise pas la création de nouveau élément (default: false; création autorisée) limit: le
nombre maximum délément autorisé (default: pas de limite) displayCount: affiche on non le nombre d'occurence du tag
(default: false; par d'affichage) value: le tableau initial des tags allTags: tous les tags disponibles emit: input: le
tableau contenant le résultat de l'édition (contient les tags) */
<template>
  <vue-tags-input
    class="tags-input"
    v-model="currentTag"
    :tags="selectedTags"
    @tags-changed="
      (t) =>
        $emit(
          'input',
          t.map((v) => v.text)
        )
    "
    :add-only-from-autocomplete="noCreation"
    :max-tags="limit"
    :autocomplete-items="filteredTags"
    :add-on-key="key"
    :save-on-key="key"
  >
    <template v-if="displayCount" #tag-right="{ tag }"> ({{ tag.count }}) </template>
  </vue-tags-input>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import VueTagsInput from '@johmun/vue-tags-input'

@Component({
  name: 'TagsInput',
  props: ['availableTags', 'noCreation', 'limit', 'displayCount', 'value'],
  components: { VueTagsInput }
})
class TagsInput extends Vue {
  @Prop availableTags
  @Prop noCreation
  @Prop limit
  @Prop displayCount
  @Prop value

  key = [13, ',', ';', ' ', '\t']
  allTagsServer = []

  get allTags() {
    if (this.availableTags) {
      if (this.availableTags.length > 0 && !this.availableTags[0].text) {
        return this.availableTags.map((text) => {
          return {text}
        })
      }
      return this.availableTags
    }

    if (this.allTagsServer.length === 0) {
      this.load()
    }

    return this.allTagsServer
  }

  currentTag = ''
  get selectedTags() {
    return this.value.map((text) => {
      return { text }
    })
  }

  get filteredTags() {
    let lowerCased = this.currentTag.toLowerCase()
    return this.allTags.filter((a) => {
      return a.text.toLowerCase().indexOf(lowerCased) !== -1
    })
  }

  load() {
    this.$fetch.get('/bookmarks/tags?with-count=true').then(
      (tags) => {
        console.log('ok', tags)
        this.allTagsServer = tags[0].map((text, i) => {
          return { text, count: tags[1][i] }
        })
      },
      (err) => {
        console.log('ko', err)
        this.errorMsg = err.cause
      }
    )
  }
}

export default TagsInput
</script>

<style lang="less">
.vue-tags-input.tags-input {
  max-width: 100%;

  .ti-input {
    width: 100%;
    padding: 2px 5px;

    color: var(--color-black);

    background-color: transparent;
    border: 1px solid var(--color-grey--lighter);
    border-radius: 3px;
  }

  .ti-new-tag-input-wrapper {
    margin: 0;
    padding: 0 var(--margin--tiny);

    input {
      min-height: 30px;
    }
  }
}
</style>
